<template>
  <div class="main-top mb10">
    <div class="row white-box main-print">
      <div class="col-lg-12">
        <span>打印步骤</span>
        <span class="print-step1 gray" :class="{active : stepNumber=='1'}">
          <i class="icon-line"></i>
          <i class="icon-step icon-step1"></i>
          1. 上传文件
        </span>
        <span class="print-step2 gray" :class="{active : stepNumber=='2'}">
          <i class="icon-line"></i>
          <i class="icon-step icon-step2"></i>
          2. 配置支付
        </span>
        <span class="print-step3 gray" :class="{active : stepNumber=='3'}">
          <i class="icon-line"></i>
          <i class="icon-step icon-step3"></i>
          3. 扫码打印
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MainTop",
    props: ['step-number']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainTop.vue